import {FETCH_CITIES_REQUEST, FETCH_CITIES_SUCCES, FETCH_CITIES_ERROR} from '../constants/Cities'

const initialState = {
  list: [],
  hasErrored: false,
  isLoading: false
}

export default function cities(state = initialState, action) {
  switch (action.type) {
      case FETCH_CITIES_REQUEST:
        return {...state, isLoading: true};
      case FETCH_CITIES_SUCCES:
        return {...state, list: action.payload.results, isLoading: false};
      case FETCH_CITIES_ERROR:
        return {...state, hasErrored: true, isLoading: false};
      default:
          return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/cities.js